import axios from "axios";

async function resolve(promise) {
  let resolved = {
    data: null,
    error: null,
  };
  try {
    resolved.data = await promise;
  } catch (e) {
    resolved.error = e.response ? e.response.data : e;
  }
  return resolved;
}

export async function sentContact(data) {
  
  return await resolve(
    axios
      .post(`https://sendmail.transforma.in/contact_api/contact.php`, data, {
      })
      .then((res) => res.data)
  );
}
export async function sentCareer(data) {
  
  return await resolve(
    axios
      .post(`https://sendmail.transforma.in/contact_api/career.php`, data, {})
      .then((res) => res.data)
  );
}

export async function sentBookFair(data) {
  
  return await resolve(
    axios
      .post(`https://transformainc.com:8449/send_email`, data, {
      })
      .then((res) => res.data)
  );
}